import { render, staticRenderFns } from "./Preguntar.vue?vue&type=template&id=6a0943e3&scoped=true&"
import script from "./Preguntar.vue?vue&type=script&lang=js&"
export * from "./Preguntar.vue?vue&type=script&lang=js&"
import style0 from "./Preguntar.vue?vue&type=style&index=0&id=6a0943e3&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0943e3",
  null
  
)

export default component.exports